export default __webpack_public_path__ + "static/media/four.63af4abd.svg";